import { render, staticRenderFns } from "./SectionInfo.vue?vue&type=template&id=402c5763&scoped=true&"
import script from "./SectionInfo.vue?vue&type=script&lang=js&"
export * from "./SectionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c5763",
  null
  
)

export default component.exports